"use client";

import { AlertTriangle } from "lucide-react";

interface IdleWarningModalProps {
  open: boolean;
  secondsLeft: number;
  onStay: () => void;
  onSignOut: () => void;
}

export function IdleWarningModal({
  open,
  secondsLeft,
  onStay,
  onSignOut,
}: IdleWarningModalProps) {
  if (!open) return null;

  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const timeDisplay =
    minutes > 0
      ? `${minutes}m ${String(seconds).padStart(2, "0")}s`
      : `${seconds}s`;

  return (
    <div
      role="dialog"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
    >
      <div className="mx-4 flex w-full max-w-md flex-col rounded-xl bg-white shadow-2xl dark:bg-zinc-900">
        {/* Header */}
        <div className="flex items-center gap-3 border-b border-zinc-200 px-5 py-4 dark:border-zinc-700">
          <AlertTriangle size={20} className="shrink-0 text-amber-500" />
          <h2 className="text-base font-semibold text-zinc-900 dark:text-zinc-100">
            Session Expiring Soon
          </h2>
        </div>

        {/* Body */}
        <div className="px-5 py-4">
          <p className="text-sm text-zinc-600 dark:text-zinc-400">
            You will be signed out due to inactivity in{" "}
            <span className="font-semibold text-zinc-900 dark:text-zinc-100">
              {timeDisplay}
            </span>
            .
          </p>
          <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-400">
            Would you like to stay signed in?
          </p>
        </div>

        {/* Actions */}
        <div className="flex justify-end gap-3 border-t border-zinc-200 px-5 py-4 dark:border-zinc-700">
          <button
            type="button"
            onClick={onSignOut}
            className="rounded-md border border-zinc-300 px-4 py-2 text-sm font-medium text-zinc-700 transition-colors hover:bg-zinc-50 dark:border-zinc-600 dark:text-zinc-300 dark:hover:bg-zinc-800"
          >
            Sign Out
          </button>
          <button
            type="button"
            onClick={onStay}
            className="rounded-md bg-black px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-zinc-800 dark:bg-white dark:text-black dark:hover:bg-zinc-200"
          >
            Stay Signed In
          </button>
        </div>
      </div>
    </div>
  );
}
